import { Classes } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";

interface ChatLoaderProps {
  position?: "static" | "relative" | "absolute" | "fixed" | "sticky";
}

export function ChatLoader({ position = "absolute" }: ChatLoaderProps) {
  return (
    <>
      <Box style={{ position, bottom: 0, left: 0, right: 0 }}>
        <YouSay height={50} />
        <YouSay height={75} />
        <YouSay height={50} />
        <YouSay height={100} />
        <YouSay height={75} />
        <Box
          mx="10px"
          mt="10px"
          mb="15px"
          height={57}
          style={{ borderRadius: 8 }}
          className={Classes.SKELETON}
        />
      </Box>
    </>
  );
}

function YouSay({ height }: { height: number }) {
  return (
    <Flex my={3} mx="10px">
      <Box
        width={32}
        height={32}
        style={{ borderRadius: "100%" }}
        className={Classes.SKELETON}
        mr={2}
      />
      <Box
        width={1}
        maxWidth={500}
        height={height}
        className={Classes.SKELETON}
        style={{ borderRadius: 6 }}
      />
    </Flex>
  );
}
